import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ShieldCheck, Lock, CheckCircle2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const fieldCls = "pl-10 h-11 bg-slate-900/70 border-slate-700 text-slate-100";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== confirm) return setError("Le password non coincidono");
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      setDone(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 grid-bg noise">
      <div className="w-full max-w-sm rise">
        <div className="flex items-center gap-2 mb-10 text-slate-300 font-mono text-xs tracking-[0.2em] uppercase">
          <ShieldCheck className="w-4 h-4 text-emerald-400" /> TrustMaster
        </div>
        <h2 className="font-display text-3xl font-bold mb-8" data-testid="reset-title">Nuova password</h2>
        {done ? (
          <div className="space-y-6" data-testid="reset-success">
            <div className="flex gap-3 rounded-lg border border-emerald-500/30 bg-emerald-500/5 p-4">
              <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" />
              <p className="text-sm text-slate-300">Password aggiornata. Ora puoi accedere con la nuova password e il codice OTP.</p>
            </div>
            <Button asChild className="w-full h-11 bg-blue-600 hover:bg-blue-700 text-white" data-testid="reset-go-login-button">
              <Link to="/login">Vai all'accesso</Link>
            </Button>
          </div>
        ) : !token ? (
          <p className="text-sm text-rose-400" data-testid="reset-missing-token">Link non valido. Richiedi un nuovo link da "Password dimenticata?".</p>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
            {[["Nuova password (min 8)", pwd, setPwd, "reset-new-password-input"], ["Conferma password", confirm, setConfirm, "reset-confirm-password-input"]].map(([ph, v, set, id]) => (
              <div className="relative" key={id}>
                <Lock className="w-4 h-4 text-slate-500 absolute left-3 top-1/2 -translate-y-1/2 z-10" />
                <Input required type="password" minLength={8} placeholder={ph} value={v} onChange={(e) => set(e.target.value)} className={fieldCls} data-testid={id} />
              </div>
            ))}
            {error && <p className="text-sm text-rose-400" data-testid="reset-error">{error}</p>}
            <Button disabled={loading} className="w-full h-11 bg-blue-600 hover:bg-blue-700 text-white" data-testid="reset-submit-button">
              {loading ? "Salvataggio…" : "Imposta nuova password"}
            </Button>
            <Link to="/login" className="block text-center text-xs text-slate-500 hover:text-slate-300" data-testid="reset-back-login-link">Torna all'accesso</Link>
          </form>
        )}
      </div>
    </div>
  );
}
